document.addEventListener("DOMContentLoaded", () => {
    const processProductItems = () => {
        let productItemAll = document.querySelectorAll('.product-item');

        productItemAll.forEach((productItem) => {
            // Prevent re-processing the same item
            if (productItem.dataset.handled === "true") return;

            let productTitle = productItem.querySelector('.product-item__title');
            if (productTitle) {
                let titleText = productTitle.innerText;
                let productHandle = titleText
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9\s-]/g, '')  // Remove special characters
                    .replace(/\s+/g, '-')          // Replace spaces with hyphens
                    .replace(/-+/g, '-');          // Replace multiple hyphens with single one

                // console.log(handle);
                if(productHandle.includes('test-product')){
                    // console.log(productHandle);
                    productItem.style.display = 'none';
                }
            }

            productItem.dataset.handled = "true"; // Mark as processed
        });
    };

    // Initial processing
    processProductItems();

    // Observer to watch for new product items
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                processProductItems();
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});
